import { progressiveFormStepper } from '../components/ProgressiveFormStepper/utils';
import { Button, Box, Grid, GridItem, Center, Image, useStyleConfig } from '@chakra-ui/react';
import BorderBox from '../components/Wrappers/BorderBox';
import NoBorderBox from '../components/Wrappers/NoBorderBox';
import SectionHeader from './SectionHeader';
import { exitToMenu } from './utils';

const SingleSection = ({ props, formikProps, navSection, index }) => {
  props.formikProps = formikProps;
  //why is this here?? const cols = navSection.hero ? 2 : 1;
  const sectionName = props.stateProps.sectionData.sectionName;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  return navSection.hero ? (
    <Grid
      templateAreas={[`form`, `form`, `form`, `"hero form"`]}
      gridTemplateColumns={[
        'repeat(1, 1fr)',
        'repeat(1, 1fr)',
        'repeat(1, 1fr)',
        '30% 70%',
      ]}
      gap={[0, 0, 0, 10]}
    >
      <GridItem
        area={[null, null, null, 'hero']}
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <Image
          sx={{
            width: [0, 0, 0, 'auto'],
          }}
          src={navSection.hero}
        />
      </GridItem>
      <GridItem area="form">
        {sectionName !== 'start' && (
          <>
            <SectionHeader navSection={navSection} props={props} />
            <BorderBox props={props} minHeight={[0, 0, '500px']}>
              {progressiveFormStepper(
                props,
                props.sections['questions'],
                index
              )}
            </BorderBox>
            <Box>
              <Button
                sx={{...buttonStyles.primary,...buttonStyles.singleSectionMenu}}
                onClick={() => exitToMenu(props)}
              >
                &lt;&lt; Menu
              </Button>
            </Box>
          </>
        )}
        {sectionName === 'start' && (
          <NoBorderBox>
            <Center minHeight={[0, 0, '500px']}>
              {progressiveFormStepper(
                props,
                props.sections['questions'],
                index
              )}
            </Center>
          </NoBorderBox>
        )}
      </GridItem>
    </Grid>
  ) : (
    <Box area="form">
      {sectionName !== 'start' && (
        <Box sx={{ padding: 0, margin: 0 }}>
          <BorderBox props={props}>
            <Center
              sx={{
                minHeight: [0, '400px', null, '500px'],
                padding: [0, 0, '16px'],
              }}
            >
              {progressiveFormStepper(
                props,
                props.sections['questions'],
                index
              )}
            </Center>
          </BorderBox>
          <Box>
            <Button
              sx={{...buttonStyles.primary,...buttonStyles.singleSectionMenu}}
              onClick={() => exitToMenu(props)}
            >
              &lt;&lt; Menu
            </Button>
          </Box>
        </Box>
      )}
      {sectionName === 'start' && (
        <NoBorderBox>
          <Center minHeight={[0, 0, '500px']}>
            {progressiveFormStepper(props, props.sections['questions'], index)}
          </Center>
        </NoBorderBox>
      )}
    </Box>
  );
};

export default SingleSection;
